import Axios from './axios'
export class MemberService {
  // 收藏-象刀设计-分类列表
  // eslint-disable-next-line require-await
  static async getCollectCategoryList(params: any) {
    return Axios('/user/collect/category_list/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  // 收藏-象刀设计-列表
  // eslint-disable-next-line require-await
  static async getCollectList(params: any) {
    return Axios('/user/collect/list/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  // 收藏-象刀ppt-列表
  // eslint-disable-next-line require-await
  static async getCollectPptList(params: any) {
    return Axios('/user/collect/ppt_list/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  // 收藏-象刀简历-列表
  // eslint-disable-next-line require-await
  static async getCollectResumeList(params: any) {
    return Axios('/user/collect/jianli_list/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  // 收藏-象刀素材-列表
  // eslint-disable-next-line require-await
  static async getCollectMaterialList(params: any) {
    return Axios('/user/collect/material_list/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  // 用户模板回收站
  // eslint-disable-next-line require-await
  static async addCollect(params: any) {
    return Axios('/user/collect/add_content/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  
  // 用户模板回收站
  // eslint-disable-next-line require-await
  static async deleteCollect(params: any) {
    return Axios('/user/collect/delete/', {
      method: 'post',
      responseType: 'json',
      data: {
        ...params
      },
    })
  }
  // 用户模板回收站
  // eslint-disable-next-line require-await
  static async orderList(params: any) {
    return Axios('/user/order/list', {
      method: 'get',
      responseType: 'json',
      params
    })
  }
  // eslint-disable-next-line require-await
  static async downloadMsg(params: any) {
    return Axios('/download/msg/', {
      method: 'get',
      responseType: 'json',
      params
    })
  }
 
  // 订单文件下载
  // eslint-disable-next-line require-await
  static async downloadFile(params: any) {
    return Axios('/download/orderfile/', {
      method: 'post',
      responseType: 'blob',
      data: {
        ...params
      },
    })
  }


}